"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcumenPullRequestStatusWithWorkStart = exports.AcumenPullRequestStatus = exports.PullRequestEventEntryType = exports.PullRequestIntegrationType = void 0;
var PullRequestIntegrationType;
(function (PullRequestIntegrationType) {
    PullRequestIntegrationType["GITHUB"] = "GITHUB";
})(PullRequestIntegrationType = exports.PullRequestIntegrationType || (exports.PullRequestIntegrationType = {}));
var PullRequestEventEntryType;
(function (PullRequestEventEntryType) {
    PullRequestEventEntryType["Committed"] = "COMMITTED";
    PullRequestEventEntryType["ReviewRequested"] = "REVIEW_REQUESTED";
    PullRequestEventEntryType["ReviewedCommented"] = "REVIEWED_COMMENTED";
    PullRequestEventEntryType["ReviewedChangesRequested"] = "REVIEWED_CHANGES_REQUESTED";
    PullRequestEventEntryType["ReviewedApproved"] = "REVIEWED_APPROVED";
    PullRequestEventEntryType["ReviewedDismissed"] = "REVIEWED_DISMISSED";
    PullRequestEventEntryType["ReadyForReview"] = "READY_FOR_REVIEW";
    PullRequestEventEntryType["ReviewDismissed"] = "REVIEW_DISMISSED";
    PullRequestEventEntryType["ReviewRequestRemoved"] = "REVIEW_REQUEST_REMOVED";
    PullRequestEventEntryType["Commented"] = "COMMENTED";
    PullRequestEventEntryType["CommentDeleted"] = "COMMENT_DELETED";
    PullRequestEventEntryType["CommitCommented"] = "COMMIT_COMMENTED";
    PullRequestEventEntryType["LineCommented"] = "LINE_COMMENTED";
    PullRequestEventEntryType["CrossReferenced"] = "CROSS_REFERENCED";
    PullRequestEventEntryType["Deployed"] = "DEPLOYED";
    PullRequestEventEntryType["Merged"] = "MERGED";
    PullRequestEventEntryType["Closed"] = "CLOSED";
    PullRequestEventEntryType["Renamed"] = "RENAMED";
    PullRequestEventEntryType["Reopened"] = "REOPENED";
    PullRequestEventEntryType["Referenced"] = "REFERENCED";
    PullRequestEventEntryType["Subscribed"] = "SUBSCRIBED";
    PullRequestEventEntryType["Unsubscribed"] = "UNSUBSCRIBED";
    PullRequestEventEntryType["Labeled"] = "LABELED";
    PullRequestEventEntryType["Unlabeled"] = "UNLABELED";
    PullRequestEventEntryType["Assigned"] = "ASSIGNED";
    PullRequestEventEntryType["Unassigned"] = "UNASSIGNED";
    PullRequestEventEntryType["Mentioned"] = "MENTIONED";
    PullRequestEventEntryType["Unknown"] = "UNKNOWN";
})(PullRequestEventEntryType = exports.PullRequestEventEntryType || (exports.PullRequestEventEntryType = {}));
// The Reviewed state actually means "Pending Merge". Read more at ACM-3030.
var AcumenPullRequestStatus;
(function (AcumenPullRequestStatus) {
    AcumenPullRequestStatus["Open"] = "OPEN";
    AcumenPullRequestStatus["AwaitingReview"] = "AWAITING_REVIEW";
    AcumenPullRequestStatus["InReview"] = "IN_REVIEW";
    AcumenPullRequestStatus["Reviewed"] = "REVIEWED";
    AcumenPullRequestStatus["Merged"] = "MERGED";
    AcumenPullRequestStatus["Closed"] = "CLOSED";
    AcumenPullRequestStatus["Unknown"] = "UNKNOWN";
})(AcumenPullRequestStatus = exports.AcumenPullRequestStatus || (exports.AcumenPullRequestStatus = {}));
var AcumenPullRequestStatusWorkStart;
(function (AcumenPullRequestStatusWorkStart) {
    AcumenPullRequestStatusWorkStart["WorkStart"] = "WORK_START";
})(AcumenPullRequestStatusWorkStart || (AcumenPullRequestStatusWorkStart = {}));
// tslint:disable-next-line: variable-name
exports.AcumenPullRequestStatusWithWorkStart = { ...AcumenPullRequestStatus, ...AcumenPullRequestStatusWorkStart };
//# sourceMappingURL=pull-request.js.map